import {
  ActivationRequiredWarning,
  PageBanner,
  QuickTable,
  QuickTableFilterTabs,
} from "../../components";
import { CreateInvoice } from "./CreateInvoice";
import { invoiceDisplayFormatter } from "./invoiceDisplayFormatter";
import { IInvoiceViewProps } from "./Invoices";

import listPadIcon from "../../assets/icons/list-pad.svg";

export const View = (props: IInvoiceViewProps) => {
  return (
    <>
      <PageBanner
        iconSource={listPadIcon}
        pageTitle={"Invoices"}
        pageSubtitle={"Generate and send invoice to your customers in minutes"}
        pageDescription={
          "Get started quickly, send invoices to your customers, monitor, export your invoices."
        }
        linkTitle={"Set up your business brand"}
        linkSubtitle={
          "Customize how your invoices look by changing the logo and color."
        }
        linkButtonText={"Brand settings"}
        linkButtonUrl={"/settings/business/brand-setup"}
      />

      <ActivationRequiredWarning
        title="To send invoices you need to activate your profile"
        subtitle="You’re almost there — our guide will help you complete your Business profile and you’ll start receiving payments. Click this banner to complete your set-up"
        urlTarget="/onboarding"
      />

      <QuickTable
        id="invoicesTable"
        data={props.data}
        headers={props.headers}
        isLoading={props.isLoading}
        isError={props.isError}
        itemCount={props.totalCount}
        renderDetail={(item) => item.description}
        toolbarTabs={
          <QuickTableFilterTabs
            queryStringTabNavLinks={props.queryStringTabs}
          />
        }
        displayFormatter={invoiceDisplayFormatter}
        onExport={props.onExport}
        openCreateNewModal={props.openCreateNewModal}
        createNewButtonText={"Create an invoice"}
      />

      <CreateInvoice
        isModalOpen={props.isCreateNewModalOpen}
        closeModal={props.closeModal}
      />
    </>
  );
};
